import { useEffect } from "react";
import useAuth from "app/hooks/useAuth";
import useSettings from "app/hooks/useSettings";
import { useTenantHost } from "./TenantHostProvider";
import { applyTenantThemeToSettings } from "./applyTenantTheme";
import {
  brandingSignature,
  resetDocumentFavicon,
  resolveFaviconHref,
  setDocumentFavicon } from
"./tenantBranding";

/**
 * Applies tenant favicon + Matx theme from:
 * 1) authenticated principal branding (preferred after login)
 * 2) public tenant host resolve (pre-login)
 * Resets to platform defaults on generic host / logout when no branding is present.
 */
export default function TenantBrandingApplier() {
  const { user, isAuthenticated } = useAuth();
  const tenantHost = useTenantHost();
  const { settings, updateSettings } = useSettings();

  useEffect(() => {
    const fromUser = isAuthenticated && user ?
    {
      logoUrl: user.logoUrl,
      faviconUrl: user.faviconUrl,
      companyLogo: user.companyLogo,
      companyFavIcon: user.companyFavIcon,
      theme: user.theme,
      appsCode: user.appsCode,
      tenantSlug: user.tenantSlug,
      hasLogo: user.hasLogo,
      hasFavicon: user.hasFavicon
    } :
    null;

    const fromHost = tenantHost?.isTenantHost ?
    {
      logoUrl: tenantHost.logoUrl,
      faviconUrl: tenantHost.faviconUrl,
      theme: tenantHost.theme,
      appsCode: tenantHost.appsCode,
      tenantSlug: tenantHost.tenantSlug,
      hasLogo: tenantHost.hasLogo,
      hasFavicon: tenantHost.hasFavicon
    } :
    null;

    const branding = fromUser || fromHost;
    if (!branding) {
      resetDocumentFavicon();
      applyTenantThemeToSettings(settings, updateSettings, null);
      return;
    }

    setDocumentFavicon(resolveFaviconHref(branding));
    applyTenantThemeToSettings(settings, updateSettings, branding.theme || null);
    // settings omitted: identity churns on every apply. brandingSignature + stable updateSettings drive updates.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
  isAuthenticated,
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional deps (preserve behavior)
  brandingSignature(user),
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional deps (preserve behavior)
  brandingSignature(tenantHost),
  tenantHost?.isTenantHost,
  updateSettings]
  );

  return null;
}